const TableCellOption = (/*{ row, column }*/) => {
  return ":";
};

export default TableCellOption;
